import React from 'react';
import { CardPrincipalIndicatorStyle } from './style';

export default function CardPrincipalIndicator({ value, description, isPositive }) {
  return (
    <div>
      <CardPrincipalIndicatorStyle isPositive={isPositive}>
        <p>
          {description} | {value}
        </p>
        {isPositive ? (
          <svg width="10" height="16" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M-4.38163e-07 13.976L-7.01087e-07 7.961L8 -3.49691e-07L16 7.961L16 13.976L8 6.015L-4.38163e-07 13.976ZM16 24L16 17.985L8 10.024L-2.62924e-07 17.985L0 24L8 16.039L16 24V24Z"
              fill="#46B285"
            />
          </svg>
        ) : (
          <svg width="10" height="16" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 10.024L16 16.039L8 24L-7.01087e-07 16.039L-4.38163e-07 10.024L8 17.985L16 10.024ZM0 -6.99382e-07L-2.62924e-07 6.015L8 13.976L16 6.015L16 0L8 7.961L0 -6.99382e-07V-6.99382e-07Z"
              fill="#E74C3C"
            />
          </svg>
        )}
      </CardPrincipalIndicatorStyle>
    </div>
  );
}
